import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Import all BackOffice24 components used in routes
import { BackOffice24Component } from './back-office24.component';
import { BackOffice24ModulesComponent } from './back-office24-modules/back-office24-modules.component';
import { BackOffice24OrderListComponent } from './back-office24-orders/back-office24-order-list/back-office24-order-list.component';
import { BackOffice24OrderDetailsComponent } from './back-office24-orders/back-office24-order-details/back-office24-order-details.component';
import { BackOffice24GatesComponent } from './back-office24-gates/back-office24-gates.component';
import { BackOffice24TravelAgencyFormComponent } from './back-office24-boka/back-office24-travel-agency/back-office24-travel-agency-form/back-office24-travel-agency-form.component';
import { AuthGuard } from '../../../guards/auth.guard';
import { ParkingComponent } from './parkings/parking.component';
import { BackOffice24ParkingCheckInOutComponent } from './back-office24-parkingcheckinout/back-office24-parkingcheckinout.component';
import { BackOffice24PricingComponent } from './back-office24-pricing/back-office24-pricing.component';
import { BackOffice24OrderShuttlebusCheckinComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-checkin/back-office24-ordershuttlebus-checkin.component';
import { BackOffice24OrderShuttlePlanningComponent } from './back-office24-shuttle/back-office24-order-shuttle-planning/back-office24-order-shuttle-planning.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component'
import { KeyTasksListComponent } from './key-tasks-list/key-tasks-list.component';
import { OrgVehiclesComponent } from './org-vehicles/org-vehicles.component';
import { BackOffice24StartComponent } from './back-office24-start/back-office24-start.component';
import { BackOffice24UsersComponent } from './back-office24-users/back-office24-users.component';
import { ArrivalDepartureListComponent } from './arrivaldeparture/arrivaldeparture-list/arrivaldeparture-list.component';
import { ReportsComponent } from './reports/reports.component';
import { CamerasComponent } from './cameras/cameras.component';
import { CustomersComponent } from './customers/customers.component';
import { OperatorsComponent } from './operators/operators.component';
import { ParkiflyUsersComponent } from './parkifly-users/parkifly-users.component';
import { ParkingFinesComponent } from './parking-fines/parking-fines.component';
import { FinanceComponent } from './finance/finance.component';
import { SettingsComponent } from './settings/settings.component';
import { InternalBookingFormComponent } from '../../../../app/parkifly-bookings/organizations/features/booking/components/form/internal-booking/internal-booking-form/internal-booking-form.component';
import { MaintenanceGatesComponent } from './maintenance-gates/maintenance-gates.component';
import { LprLogDetailsPageComponent } from './lpr-logs/lpr-log-details-page/lpr-log-details-page.component';
import { RouteSchedulesComponent } from './route-schedules/route-schedules.component';
import { GpsTrackingComponent } from './gps-tracking/gps-tracking.component';
import { MyBusComponent } from './my-bus/my-bus.component';

export const BackOffice24Routes: Routes = [
  { path: '', redirectTo: '/start', pathMatch: 'full' },

  {
    path: 'backoffice24/:organizationId',
    component: BackOffice24Component,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: BackOffice24StartComponent, canActivate: [AuthGuard], pathMatch: 'full' },
      { path: 'dashboard', component: KeyTasksListComponent, canActivate: [AuthGuard] },
      { path: 'order-list', component: BackOffice24OrderListComponent, canActivate: [AuthGuard] },
      { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard] },
      { path: 'finance', component: FinanceComponent, canActivate: [AuthGuard] },
      { path: 'pricing', component: BackOffice24PricingComponent, canActivate: [AuthGuard] },
      { path: 'parking', component: ParkingComponent, canActivate: [AuthGuard] },
      { path: 'cameras', component: CamerasComponent, canActivate: [AuthGuard] },
      { path: 'parking-fines', component: ParkingFinesComponent, canActivate: [AuthGuard] },
      { path: 'settingss', component: SettingsComponent, canActivate: [AuthGuard] },
      { path: 'parkiflyusers', component: ParkiflyUsersComponent, canActivate: [AuthGuard] },
      { path: 'operators', component: OperatorsComponent, canActivate: [AuthGuard] },
      { path: 'customers', component: CustomersComponent, canActivate: [AuthGuard] },
      { path: 'route-schedules', component: RouteSchedulesComponent, canActivate: [AuthGuard] },
      { path: 'gps-tracking', component: GpsTrackingComponent, canActivate: [AuthGuard] },
      { path: 'my-bus', component: MyBusComponent, canActivate: [AuthGuard] },

      // All Under FLYGETS
      { path: 'shuttle-planning', component: BackOffice24OrderShuttlePlanningComponent, canActivate: [AuthGuard] },
      { path: 'travel-agency-form', component: InternalBookingFormComponent, canActivate: [AuthGuard] },
      // { path: 'travel-agency-form', component: BackOffice24TravelAgencyFormComponent, canActivate: [AuthGuard] },
      { path: 'shuttle-checkin', component: BackOffice24OrderShuttlebusCheckinComponent, canActivate: [AuthGuard] },
      { path: 'gates', component: BackOffice24GatesComponent, canActivate: [AuthGuard] },
      { path: 'parking-checkinout', component: BackOffice24ParkingCheckInOutComponent, canActivate: [AuthGuard] },
      { path: 'arrivaldepartures', component: ArrivalDepartureListComponent, canActivate: [AuthGuard] },
      { path: 'vehicles', component: OrgVehiclesComponent, canActivate: [AuthGuard] },
      { path: 'users', component: BackOffice24UsersComponent, canActivate: [AuthGuard] },
      { path: 'maintenance', component: MaintenanceGatesComponent, canActivate: [AuthGuard] },

      { path: '**', component: ComingSoonComponent, canActivate: [AuthGuard] },
    ]
  },
  { path: 'backoffice24/Me', component: BackOffice24Component, canActivate: [AuthGuard] },
  { path: 'backoffice24', component: BackOffice24Component, canActivate: [AuthGuard] },
  { path: 'backoffice24Gates/:organizationId', component: BackOffice24GatesComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'backoffice24/back-office24-travel-agency-form', component: BackOffice24TravelAgencyFormComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'back-office24-order/:orderId', component: BackOffice24OrderDetailsComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'back-office24-order-list/:organizationId', component: BackOffice24OrderListComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'lpr-log-details/:organizationId/:logId', component: LprLogDetailsPageComponent, canActivate: [AuthGuard], pathMatch: 'full' },
];

